module.exports = __webpack_public_path__ + "static/media/link-walink slp.e7e10d72.png";